/**
 * Canonical list of Frontegg feature entitlement keys that apps/extensions
 * can declare and receive through the bridge.
 *
 * Internal-only keys (e.g. BetaAccessFull, UnpublishedManifests) live
 * in api-core's extensions-registry enum, which extends this shared set.
 */
export enum FronteggExtensionsFeatureKeys {
  AppsCbtActivities = 'apps-cbt-activities',
  AppsDialInBeta = 'apps-dial-in-beta',
  AppsMeetRedirectBeta = 'apps-meet-redirect-beta',
  AppsIssueReportBeta = 'apps-issue-report-beta',
  AppsSchedulerBeta = 'apps-scheduler-beta',
  AppsInAppAnnouncementsBeta = 'apps-in-app-announcements-beta',
  AppsReference = 'apps-reference',
  AppsEmdr = 'apps-emdr',
  AppsPayment = 'apps-payment',
  AppsAgenda = 'apps-agenda',
  AppsAssessments = 'apps-assessments',
  AppsFileTransfer = 'apps-file-transfer',
  AppsPhotoCapture = 'apps-photo-capture',
  AppsBundleFileTransferPhotoCapture = 'apps-bundle-file-transfer-photo-capture',
  AppsFax = 'apps-fax',
  AppsGames = 'apps-games',
  AppsInterpreter = 'apps-interpreter',
  AppsRecord = 'apps-record',
  AppsTeleconsent = 'apps-teleconsent',
  AppsTranscript = 'apps-transcript',
  AppsWhiteboard = 'apps-whiteboard',
  AppsTimer = 'apps-timer',
  AppsNotepad = 'apps-notepad',
  AppsScribe = 'apps-scribe',
}

/**
 * Canonical list of app-level permissions granted to users via Frontegg.
 *
 * Hotpot capabilities (`hotpot:*`) describe what an actor is allowed to
 * do against hotpot. Extension manifests declare a subset via the
 * `extension-token` capability; mint-time intersection with the user's
 * Frontegg permissions produces the token's `scope.entitlements` claim,
 * enforced by hotpot's RLS.
 */
export enum FronteggExtensionsPermissionKeys {
  AppUser = 'app-user',
  AppAdmin = 'app-admin',
  AppOwner = 'app-owner',
  HotpotStashRead = 'hotpot:stash:read',
  HotpotStashWrite = 'hotpot:stash:write',
  HotpotJournalWrite = 'hotpot:journal:write',
  HotpotMessagesRead = 'hotpot:messages:read',
  HotpotVisitRead = 'hotpot:visit:read',
}
